import React, { Component } from "react";
import { withModulesManager, withHistory } from "@openimis/fe-core";
import { injectIntl } from "react-intl";
import { Box, Tabs, Tab } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import InsureeEnrollmentSearcher from "./InsureeEnrollmentSearcher";
import FamilyEnrollmentSearcher from "./FamilyEnrollmentSearcher";
import PolicyHolderEnrollmentSearcher from "./PolicyHolderEnrollmentSearcher";
import HealthFacilityEnrollmentSearcher from "./HealthFacilityEnrollmentSearcher";
import InsureeAccountClaimSearcher from "./InsureeAccountClaimSearcher";
import PolicyHolderEnrollmentBatchSearcher from "./PolicyHolderEnrollmentBatchSearcher";

const styles = (theme) => ({
  root: {
    margin: theme.spacing(1),
  },
});

class EnrollmentTable extends Component {
  state = {
    value: 0,
  };

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  };

  a11yProps = (index) => ({
    id: `enrollment-tab-${index}`,
    "aria-controls": `enrollment-tabpanel-${index}`,
  });

  openDetail = (type, enrollment) => {
    if (this.props.history && enrollment?.uuid) {
      this.props.history.push(`/enrollment/${type}/${enrollment.uuid}/detail`);
    }
  };

  render() {
    const { value } = this.state;
    const { classes } = this.props;

    return (
      <Box className={classes.root}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={this.handleChange}
            aria-label="enrollment tabs"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="Insuree Enrollment" {...this.a11yProps(0)} />
            <Tab label="Family Enrollment" {...this.a11yProps(1)} />
            <Tab label="Policy Holder Enrollment" {...this.a11yProps(2)} />
            <Tab label="Health Facility Enrollment" {...this.a11yProps(3)} />
            <Tab label="Account Claim" {...this.a11yProps(4)} />
            <Tab label="PH Enrollment Batch" {...this.a11yProps(5)} />
          </Tabs>
        </Box>

        {value === 0 && (
          <InsureeEnrollmentSearcher
            cacheFiltersKey="enrollmentHomeInsureeFiltersCache"
            onDoubleClick={(e) => this.openDetail("insuree", e)}
          />
        )}
        {value === 1 && (
          <FamilyEnrollmentSearcher
            cacheFiltersKey="enrollmentHomeFamilyFiltersCache"
            onDoubleClick={(e) => this.openDetail("family", e)}
          />
        )}
        {value === 2 && (
          <PolicyHolderEnrollmentSearcher
            cacheFiltersKey="enrollmentHomePolicyHolderFiltersCache"
            onDoubleClick={(e) => this.openDetail("policyholder", e)}
          />
        )}
        {value === 3 && (
          <HealthFacilityEnrollmentSearcher
            cacheFiltersKey="enrollmentHomeHealthFacilityFiltersCache"
            onDoubleClick={(e) => this.openDetail("healthfacility", e)}
          />
        )}
        {value === 4 && (
          <InsureeAccountClaimSearcher
            cacheFiltersKey="enrollmentHomeAccountClaimFiltersCache"
            onDoubleClick={(e) => this.openDetail("account-claim", e)}
          />
        )}
        {value === 5 && (
          <PolicyHolderEnrollmentBatchSearcher
            cacheFiltersKey="enrollmentHomePolicyHolderBatchFiltersCache"
            onDoubleClick={(e) => this.openDetail("policyholder-batch", e)}
          />
        )}
      </Box>
    );
  }
}

export default withModulesManager(
  withHistory(withStyles(styles)(injectIntl(EnrollmentTable)))
);
